/**
 * Route path constants -- single source of truth for all Promote URLs.
 * All paths use TanStack Router's $ prefix for dynamic segments.
 */
export const ROUTES = {
  // ---- Root ----
  root: '/',

  // ---- Auth ----
  login: '/login',
  selectOrganization: '/select-organization',
  createOrganization: '/create-organization',
  ssoCallback: '/auth/sso/callback',

  // ---- Promote Dashboard ----
  promote: '/promote',

  // ---- Error pages ----
  unauthorized: '/promote/unauthorized',

  // ---- Accounts ----
  accounts: '/promote/accounts',
  accountsConnect: '/promote/accounts/connect/$platform',

  // ---- Campaigns ----
  campaigns: '/promote/campaigns',
  campaignsNew: '/promote/campaigns/new',
  campaignDetail: '/promote/campaigns/$id',
  campaignEdit: '/promote/campaigns/$id/edit',
  /** Isolated Stripe checkout; not linked from the launch flow. */
  campaignCheckout: '/promote/campaigns/$id/checkout',

  // ---- Analytics ----
  analytics: '/promote/analytics',

  // ---- Notifications ----
  notifications: '/promote/notifications',

  // ---- Settings ----
  settings: '/promote/settings',

  // ---- Admin ----
  admin: '/promote/admin',
  adminCampaignReview: '/promote/admin/campaigns/$id',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
